import { sendLog } from "./sendLog";
export const isAllowedUri = (url, layerConfig) => {
    if (url === "") {
        return false;
    }
    try {
        const config = layerConfig !== null && layerConfig !== void 0 ? layerConfig : window.nexus.configuration;
        const allowed = (() => {
            const whiteList = config.navigateWhitelist;
            if (whiteList == null) {
                if (process.env.MODE === "development") {
                    return url.startsWith("http:") || url.startsWith("https:");
                }
                return url.startsWith("https:");
            }
            return whiteList.some((value) => {
                return url.startsWith(value);
            });
        })();
        if (!allowed) {
            sendLog(`Path configuration issue detected: ${url}`);
            return false;
        }
        else {
            return true;
        }
    }
    catch (error) {
        if (error instanceof Error) {
            sendLog(`Path configuration issue detected (error validating): ${error.message}`);
        }
        console.warn(error);
    }
    return false;
};
